import React, { Component } from 'react';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <h2>flocked-pixels</h2>
        </header>
      </div>
    );
  }
}

export default App;
